import type { Phrases } from '../common/Phrases.d';

import React, { useEffect, useRef } from 'react';
import { useWatch } from 'react-hook-form';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { Span } from '/react4xp/components/Element';
import { TextField } from '/react4xp/components/react-hook-form/TextField';
import {
	type SubstanceForm,
	COMMON_FIELD_NAME,
	SUBSTANCE_FORM,
} from './constants';


export const getIntoxicantDescriptionLabel = ({
	phrases,
	substanceForm,
}: {
	substanceForm: SubstanceForm;
	phrases: Phrases;
}): string => phrases[`notificationForm.common.${
	substanceForm === SUBSTANCE_FORM.CAPSULE
		? 'capsule'
		: substanceForm === SUBSTANCE_FORM.PILL
			? 'pill'
			: 'formOther'
}DescriptionField.label`];


export const IntoxicantDescriptionTextField = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const {
		control,
		setScrollRef,
	} = useFormContext();
	const scrollRef = useRef();
	const form: SubstanceForm = useWatch({ control, name: COMMON_FIELD_NAME.SUBSTANCE_FORM }) as SubstanceForm;
	const label = getIntoxicantDescriptionLabel({
		phrases,
		substanceForm: form,
	});

	useEffect(() => {
		if (scrollRef.current) {
			setScrollRef({ field: COMMON_FIELD_NAME.INTOXICANT_DESCRIPTION, el: scrollRef.current });
		}
	}, [scrollRef.current]);

	return (
		<TextField
			errorSummaryLabel={label}
			fullWidth
			label={<Span
				className='text-lg'
				elementRef={scrollRef}
			>{label}</Span>}
			name={COMMON_FIELD_NAME.INTOXICANT_DESCRIPTION}
			showIf={({ watch }) => [
				SUBSTANCE_FORM.CAPSULE,
				SUBSTANCE_FORM.PILL,
				SUBSTANCE_FORM.OTHER,
			].includes(watch({ name: COMMON_FIELD_NAME.SUBSTANCE_FORM }))}
		/>
	);
};
